import { render, staticRenderFns } from "./Certify.vue?vue&type=template&id=6861cabc&scoped=true"
import script from "./Certify.vue?vue&type=script&lang=js"
export * from "./Certify.vue?vue&type=script&lang=js"
import style0 from "./Certify.vue?vue&type=style&index=0&id=6861cabc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861cabc",
  null
  
)

export default component.exports